import { Grid } from "modules/common/components/Grid";
import config from "config/config";
import { useTranslations } from "contexts/LocalizationContext";
import Subscribe from "components/Subscribe";
import { Box } from "@chakra-ui/react";

const JoinTheCommunity = () => {
  const translations = useTranslations();

  return (
    <Box
      bgRepeat="no-repeat"
      bgImage={{
        base: "none",
        md: `url(${config.staticUrl}/i/homepage/decoration-img-triangles.svg)`,
      }}
      bgColor="primary.900"
      bgPosition="right bottom"
      py={{ base: 10, lg: 16 }}
      mb={{ base: 14, lg: 24 }}
    >
      <Grid mb={0}>
        <Box gridColumn={{ md: "span 12" }} color="white">
          <Subscribe
            heading={translations("join_the_community")}
            text={translations("pick_up_tips")}
            buttonText={translations("subscribe")}
          />
        </Box>
      </Grid>
    </Box>
  );
};

export default JoinTheCommunity;
